class Browser {
	name = 'unknow'
	version = 'unknow'
	device  = 'unknow'
	platform = 'unknow'
	isIE = false
	isIE6 = false
	isIE7 = false
	isIE8 = false
	isIE678 = false
	isIE9 = false
	isIE10 = false
	isIE11 = false
	isChrome = false
	isFirefox = false
	isMicroMessenger = false
	isOpera = false
	isSafari = false
	isEdge = false
	isWindows = false
	isMac = false
	isiPhone = false
	isiPad = false
	isiPod = false
	isAndriod = false
	isLinux = false
}


var browserRegs = [{
	name : 'oIE',
	test :  /msie ([\d.]+)/
},{
	name : 'IE',
	test : /trident.+rv:([\d.]+)/
},{
	name : 'Edge',
	test : /edge\/([\d.]+)/
},{
	name : 'MicroMessenger',
	test : /micromessenger.([\d.]+)/	
},{
	name : 'Chrome',
	test : /chrome\/([\d.]+)/	
},{
	name : 'Firefox',
	test : /firefox\/([\d.]+)/	
},{
	name : 'Opera',
	test : /opera.([\d.]+)/	
},{
	name : 'Safari',
	test : /version\/([\d.]+).*safari/
}]

var platforms : {[key : string] : RegExp} = {
	Windows : /windows nt/
	,Mac : /macintosh/
	// ,WindowsPhone : /windows phone/
	,iPhone : /iphone/
	,iPad : /ipad/
	,iPod : /ipod/
	,Android : /android/
	,Linux : /linux/
}

var IEVersions = [6,7,8,9,10,11]
type UnPick<T,U> = Pick<T,Exclude<keyof T,U>>
type IsField =  keyof UnPick<Browser,'name' | 'version' | 'device' | 'platform'>

export function parseBrowser (ua : string) {
	var browser = new Browser
	if (ua) {
		ua = ua.toLowerCase()
		return parsePlatform(_parseBrowser(browser,ua),ua)
	}else{
		return browser
	}
}

function _parseBrowser (browser : Browser,ua : string) {
	var i ,len
	for(i = 0,len = browserRegs.length; i<len; i++){
		var result = browserRegs[i].test.exec(ua)
		if (result){
			browser.name = (browserRegs[i].name === 'oIE') ? 'IE' : browserRegs[i].name
			browser.version = result[1]
			break
		}
	}
	for(i = 0,len = browserRegs.length; i < len; i++){
		var name = browserRegs[i].name
		if (name === 'oIE') { 
			name = 'IE'
		}
		browser[('is'+name) as IsField] = ( browser.name === name )
	}
	for (i = IEVersions.length - 1; i >= 0; i--) {
		browser[('isIE' + IEVersions[i]) as IsField] = ( browser.name === 'IE' && parseInt(browser.version,10) === IEVersions[i] )
	}
	browser.isIE678 = browser.isIE6 || browser.isIE7 || browser.isIE8 
	return browser
}

function parsePlatform (browser : Browser,ua : string) {
	for(var key in platforms){
		browser[('is'+ key) as IsField] = platforms[key].test(ua)
	}
	return browser
}